import { z } from 'zod';
import { paginationQuery } from './common.js';
/**
 * Actividad de la API de integración: cada llamada que hace un sistema externo queda registrada para
 * monitorear el uso, entender los errores y, a futuro, cobrar por comprobante emitido.
 */
export const API_ENDPOINTS = ['documentos', 'consulta', 'crear_cliente', 'otro'];
export const API_ENDPOINT_LABEL = {
    documentos: 'Emitir documento',
    consulta: 'Consultar documento',
    crear_cliente: 'Crear cliente',
    otro: 'Otro',
};
export const apiActivityQuery = paginationQuery.extend({
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    result: z.enum(['all', 'ok', 'error']).default('all'),
    endpoint: z.enum(API_ENDPOINTS).optional(),
    /** Busca por consecutivo, clave, numero_control o texto del error. */
    search: z.string().trim().max(100).optional(),
});
export const apiUsageQuery = z.object({
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
});
export const adminApiUsageQuery = z.object({
    /** yyyy-MM; por defecto el mes actual (hora de Costa Rica). */
    month: z
        .string()
        .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
        .optional(),
});
//# sourceMappingURL=api-activity.js.map